import OurAIView from "./OurAIView";

export default OurAIView;
